export const updateUrlParams = (
  params: URLSearchParams,
  route?: (path: string) => void,
) => {
  const paramString = params.toString();
  const newPath = paramString
    ? `/conversations?${paramString}`
    : `/conversations`;

  if (route) {
    // Use preact-iso routing to trigger re-render
    route(newPath);
  } else {
    // Fallback to history API (won't trigger re-render)
    globalThis.history.replaceState(null, "", newPath);
  }
};

export const conversationLink = (conversationId: string) =>
  `${globalThis.location.origin}/conversation/${
    encodeURIComponent(conversationId)
  }`;

export const conversationsWithGroupLink = (groupId: string) =>
  `${globalThis.location.origin}/conversations?groupId=${
    encodeURIComponent(groupId)
  }`;
